import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { FilledCheckbox } from "components/Checkbox";
import { SearchInput } from "components/Input";
import { useTranslation } from "react-i18next";

type TransientJobInputToolbarProps = {
  allSelected: boolean;
  disabled: boolean;
  onDownload: () => void;
  onSearch: (value: string) => void;
  onToggleAll: () => void;
  search: string;
};

export const TransientJobInputToolbar = ({
  allSelected,
  disabled,
  onDownload,
  onSearch,
  onToggleAll,
  search,
}: TransientJobInputToolbarProps) => {
  const { t } = useTranslation();
  return (
    <Stack className="mb-3 w-full justify-between gap-4">
      <FilledCheckbox checked={allSelected} className="min-w-0 gap-2" onChange={onToggleAll}>
        <p className="shrink-0 text-lds-foreground-heading-initial font-ds-headline-sm">
          {t("Execution.transient.jobDetails.inputFiles")}
        </p>
      </FilledCheckbox>
      <Stack className="shrink-0 items-center gap-3">
        <SearchInput
          debounceTime={300}
          height="4rem"
          label={t("Execution.transient.jobDetails.searchFiles")}
          onChange={(event) => onSearch(event.target.value)}
          type="search"
          value={search}
          width="22rem"
        />
        <Button disabled={disabled} height="4rem" onClick={onDownload} startIconName="Download" variant="secondary">
          {t("Execution.transient.jobDetails.downloadSelected")}
        </Button>
      </Stack>
    </Stack>
  );
};
